import React from "react";
import { NavItem } from "./LinkItem";
import LinkItem from "./LinkItem";
import CollapseLinkItem from "./CollapseLinkItem";
import { menus } from "./mainListMock";

const MainList = () => {
  return (
    <div>
      {menus.map((menu: NavItem, idx: number) => {
        if (menu.children) {
          return <CollapseLinkItem key={idx} navItem={menu} />;
        } else {
          return <LinkItem key={idx} navItem={menu} />;
        }
      })}
    </div>
  );
};

export default MainList;
